<template>
    <div class="statistic-results">
        <table class="control-table">
            <tbody>
                <template v-if="!loading">
                    <tr v-if="noData" class="control-table__row">
                        <td class="table__cell table__cell--centered table__empty" colspan="2">
                            <span v-t="'crm.statistic.noData'" />
                        </td>
                    </tr>
                    <tr v-else-if="notFound" class="control-table__row">
                        <td class="table__cell table__cell--centered table__empty" colspan="2">
                            <span v-t="'crm.statistic.noResults'" />
                        </td>
                    </tr>
                </template>
                <tr v-for="item in computedItems" :key="item.id" class="control-table__row">
                    <td class="control-table__cell">
                        <span v-text="item.label" />
                    </td>
                    <td class="control-table__cell">
                        <span v-text="item.value.toLocaleString()" />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: 'StatisticResults',
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        isEmpty: {
            type: Boolean,
        },
        notFound: {
            type: Boolean,
            default: false,
        },
        items: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        noData() {
            const { length } = this.items;
            const { isEmpty } = this;
            return isEmpty || !length;
        },
        computedItems() {
            if (this.noData || this.notFound) return [];
            return this.items.map((item) => {
                let { entity = {}, label } = item;
                label = entity.label || label;

                return {
                    ...item,
                    label,
                };
            });
        },
    },
};
</script>

<style lang="scss" src="./StatisticResults.scss"></style>
